import React, { useState } from "react";
import "./PartnerWithUsComparison.css"; // Custom CSS
import { Link } from "react-router-dom";

const plans = ["Classified", "Freemium", "Gold", "Platinum"];

const planData = {
    Classified: {
        price: "₹0/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "0",
            "0",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "❌",
            "❌",
            "Automatic Only",
            "1 Automatic / Lead",
            "Service Price + Markup",
            "❌",
            "✔️",
            "NA",
            "❌",
            "❌",
            "❌",
            "❌",
            "❌",
            "❌",
            "NA",
            "NA",
            "100",
            "❌",
        ],
    },
    Freemium: {
        price: "₹24000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "₹600",
            "₹5000",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "❌",
            "❌",
            "Automatic + 10 Manual",
            "1 Auto + 1 Manual",
            "Service Price",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "300",
            "✔️",
            "10%",
            "10%",
            "100",
            "❌",
        ],
    },
    Gold: {
        price: "₹36000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "₹5000",
            "₹36000",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "100",
            "1 Auto + 2 Manual",
            "Service Price",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "300",
            "✔️",
            "8%",
            "8%",
            "50",
            "✔️",
        ],
    },
    Platinum: {
        price: "₹48000/-",
        note: "(Taxes Extra)",
        trial: "(1 Month Free Trial)",
        features: [
            "₹6000",
            "₹48000",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "Unlimited",
            "1 Auto + Unlimited Manual",
            "Service Price",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "✔️",
            "300",
            "✔️",
            "12%",
            "12%",
            "25",
            "✔️",
        ],
    },
};

const featuresTitle = [
    "Monthly",                                  // 0
    "Annually",                                 // 1
    "Real-time Notifications",                  // 2
    "Dedicated Key Account Manager",            // 3
    "Event Pass Selling",                       // 4
    "Quotes Offered Transparency",              // 5
    "Multiple Package Display",                 // 6
    "Lead Closure Status Notification",         // 7
    "PartyWitty Recommendation Badge",          // 8
    "Bidding Limit",                            // 9
    "Bidding Attempts",                         //10
    "Price to Customer",                        //11
    "Coupon from PW",                           //12
    "Artist Hiring",                            //13
    "Custom Profile Review",                    //14
    "Verified Reviews for Venues",              //15
    "Influencer Visits at Venue",               //16
    "Owner's Voice (Podcast)",                  //17
    "Banner Space on Website",                  //18
    "Notifications",                            //19
    "Table Booking Add-on with Minimum Guarantee", //20
    "Table Booking Add-on Commission",          //21
    "Group Booking Commission",                 //22
    "Discounted Table Booking (Commission)",    //23
    "Sponsorship First Preference",             //24
];

/** Define collapsible groups using feature indices */
const rowGroups = [
    // { type: "row", keys: [0, 1] }, 

    { type: "group", label: "Core Features", keys: [2, 3, 4, 5, 6], defaultOpen: true },

    { type: "group", label: "Advanced Features", keys: [7, 8, 9, 10, 11, 12], defaultOpen: false },

    { type: "group", label: "Premium Add-ons", keys: [13, 14, 15, 16, 17, 18, 19, 20], defaultOpen: false },

    { type: "group", label: "Commission & Discount", keys: [21, 22, 23, 24], defaultOpen: false },
];

const PartnerWithUsComparison = () => {
    const [activeTab, setActiveTab] = useState("Classified");

    // open state for groups
    const initialOpen = rowGroups
        .filter((g) => g.type === "group")
        .reduce((acc, g) => {
            acc[g.label] = !!g.defaultOpen; // only one will be true
            return acc;
        }, {});


    const [openGroups, setOpenGroups] = useState(initialOpen);
    const toggleGroup = (label) =>
        setOpenGroups((s) => ({ ...s, [label]: !s[label] }));

    return (
        <div className="partner-with-us-comparison-section">
            <h1>Comparison</h1>

            {/* Mobile Tabs */}
            <div className="partner-with-us-mobile-tabs">
                {plans.map((plan) => (
                    <div
                        key={plan}
                        className={`partner-with-us-tab ${activeTab === plan ? "active" : ""}`}
                        onClick={() => setActiveTab(plan)}
                    >
                        {plan}
                    </div>
                ))}
            </div>

            {/* Mobile View: Single Column Table (with collapsible groups) */}
            <div className="partner-with-us-mobile-table">
                <div className="partner-with-us-plan-header">
                    <h3>{activeTab}</h3>
                    <p className="partner-with-us-trial">{planData[activeTab].trial}</p>
                    <h4>
                        {planData[activeTab].price}{" "}
                        <span className="partner-with-us-note">
                            {planData[activeTab].note}
                        </span>
                    </h4>
                </div>

                <table>
                    <tbody>
                        {rowGroups.map((block, idx) => {
                            if (block.type === "row") {
                                return block.keys.map((k) => (
                                    <tr key={`m-row-${idx}-${k}`}>
                                        <td>{featuresTitle[k]}</td>
                                        <td>{planData[activeTab].features[k]}</td>
                                    </tr>
                                ));
                            }
                            const isOpen = !!openGroups[block.label];
                            return (
                                <React.Fragment key={`m-grp-${block.label}`}>
                                    <tr
                                        className="pw-collapse-header"
                                        onClick={() => toggleGroup(block.label)}
                                    >
                                        <td colSpan={2}>
                                            <span className={`chev ${isOpen ? "open" : ""}`}>{isOpen ? "-" : "+"}</span>
                                            {block.label}
                                        </td>
                                    </tr>
                                    {isOpen &&
                                        block.keys.map((k) => (
                                            <tr key={`m-item-${block.label}-${k}`}>
                                                <td>{featuresTitle[k]}</td>
                                                <td>{planData[activeTab].features[k]}</td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Desktop View: Full Table (with collapsible groups) */}
            <table className="partner-with-us-comparison-table-container">
                <thead>
                    <tr className="partner-with-us-comparison-table-header">
                        <th></th>
                        {plans.map((plan) => (
                            <th key={plan}>
                                <div className="partner-with-us-comparison-table-header-content">
                                    <h3>{plan}</h3>
                                    <p className="partner-with-us-trial">{planData[plan].trial}</p>
                                    <h4>
                                        {planData[plan].price}{" "}
                                        <span className="partner-with-us-note">
                                            {planData[plan].note}
                                        </span>
                                    </h4>
                                    {/* <Link to='/business-registration' className="partner-with-us-select">Select</Link> */}
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rowGroups.map((block) => {
                        if (block.type === "row") {
                            return block.keys.map((k) => (
                                <tr key={`d-row-${k}`} className="partner-with-us-comparison-table-row">
                                    <td>{featuresTitle[k]}</td>
                                    {plans.map((plan) => (
                                        <td key={`${plan}-${k}`}>{planData[plan].features[k]}</td>
                                    ))}
                                </tr>
                            ));
                        }

                        const isOpen = !!openGroups[block.label];

                        return (
                            <React.Fragment key={`d-grp-${block.label}`}>
                                {/* Group header row */}
                                <tr
                                    className="partner-with-us-comparison-table-row pw-collapse-header"
                                    onClick={() => toggleGroup(block.label)}
                                >
                                    <td colSpan={plans.length + 1}>
                                        <span className={`chev ${isOpen ? "open" : ""}`}>{isOpen ? "-" : "+"}</span>
                                        {block.label}
                                    </td>
                                </tr>

                                {/* Child rows */}
                                {isOpen &&
                                    block.keys.map((k) => (
                                        <tr key={`d-item-${block.label}-${k}`} className="partner-with-us-comparison-table-row">
                                            <td>{featuresTitle[k]}</td>
                                            {plans.map((plan) => (
                                                <td key={`${plan}-${k}`}>{planData[plan].features[k]}</td>
                                            ))}
                                        </tr>
                                    ))}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default PartnerWithUsComparison;
